import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateMercuryModelAssumedOrderMargin = {
  name: "updateMercuryModelAssumedOrderMargin" as const,
  input: z.object({
    mercuryModelId: zExt.objectId(),
    assumedOrderMargin: z.object({
      percentage: z.number().optional(),
      fixed: z.number().optional(),
    }),
  }),
  output: z.null(),
};
